import { HotWaterType } from './system-details-form-types';

export const DEFAULT_HOT_WATER_POWER_RATING_KW = 3.6;
export const DEFAULT_HOT_WATER_DAILY_RUNTIME_MINUTES = 240;
export const APPLIANCE_TYPE_TO_HOT_WATER_TYPE: Record<string, HotWaterType> = {
  load_hot_water: 'resistive',
  load_hot_water_heat_pump: 'heatPump',
  load_hot_water_solar: 'solar',
  load_other: undefined,
};
type HotWaterTypeStrict = Exclude<HotWaterType, undefined>;
export const HOT_WATER_TYPE_TO_APPLIANCE_TYPE: Record<HotWaterTypeStrict, string> = {
  resistive: 'load_hot_water',
  heatPump: 'load_hot_water_heat_pump',
  solar: 'load_hot_water_solar',
};
